import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboard from "./pages/UserDashboard";
import PhotoGallery from "./pages/PhotoGallery";
import SelfieVerification from "./pages/SelfieVerification";
import { AuthProvider } from "./context/AuthContext.jsx";
import { UploadProvider } from "./context/UploadContext.jsx";
import ProtectedRoute from "./components/ProtectedRoute";
import UploadStatusBox from "./components/UploadStatusBox";
import Sidebar from "./components/Sidebar.jsx";
import Header from "./components/Header.jsx";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import FolderManager from "./components/FolderManager.jsx";

function LayoutWithSidebar({ children }) {
  return (
    <div className="flex flex-1 overflow-hidden">
      {/* Sidebar on left below header */}
      <Sidebar className="w-64 border-r border-gray-200 bg-white" />

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto bg-gradient-to-br from-blue-50 via-white to-emerald-50 p-4">
        {children}
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();

  const isLandingPage =
    location.pathname === "/" || location.pathname.startsWith("/verify");

  return (
    <div className="flex flex-col h-screen">
      {/* Header at top */}
      <Header />

      {isLandingPage ? (
        // No sidebar for landing page
        <div className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/" element={<LandingPage />} />
             <Route path="/verify/:eventId" element={<SelfieVerification />} />
          </Routes>
        </div>
      ) : (
        // With sidebar for other pages
        <LayoutWithSidebar>
          <Routes>
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/user" element={<UserDashboard />} />
            <Route
              path="/events/:eventId/photos"
              element={
                <ProtectedRoute requiredRole="admin">
                  <PhotoGallery />
                </ProtectedRoute>
              }
            />

            <Route
              path="/events/:eventId/setting"
              element={
                <ProtectedRoute requiredRole="admin">
                  <h1>Setting</h1>
                </ProtectedRoute>
              }
            />

            <Route
              path="/events"
              element={
                <ProtectedRoute requiredRole="admin">
                  <FolderManager />
                </ProtectedRoute>
              }
            />
          </Routes>
        </LayoutWithSidebar>
      )}

      {/* Always visible upload status box */}
      <UploadStatusBox />
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <UploadProvider>
          <Router>
            <AppContent />
          </Router>
        </UploadProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;
